import { render, staticRenderFns } from "./Lamp.vue?vue&type=template&id=99c2d1aa"
import script from "./Lamp.vue?vue&type=script&lang=js"
export * from "./Lamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports